import '@/shared/csrf-token-deprecated';

import $ from '@/bundles/jquery';
import HireModal from "@/shared/3d-models/hire-modal";
import redirect from "@/shared/redirect";
import SubmitLoading from "@/shared/submit-loading";

import Toolbox from "../toolbox";

class HireButton {
    constructor($btn) {
        this.active = false;

        this.$btn = $btn;
        this.userId = $btn.data("user");

        this.init();
    }

    init() {
        var self = this;

        this.$btn.on("click", function () {
            if (self.$btn.hasClass("loading")) {
                return false;
            }

            if (self.$btn.hasClass("js-login-open")) {
                return false;
            }

            if (self.$btn.hasClass("disabled")) {
                return false;
            }

            self.request(!self.active);
        });
    }

    actsAsLoginButton() {
        return this.$btn.hasClass("js-login-open");
    }

    enable() {
        this.$btn.removeClass("disabled");
        this.$btn.removeAttr("disabled");
    }

    disable() {
        this.$btn.addClass("disabled");
        this.$btn.attr("disabled", true);
    }

    request() {
        var self = this;

        this.$btn.addClass("loading");
        SubmitLoading.startLoading(this.$btn);

        var url = "/api/v1/hire/" + this.userId;

        $.ajaxCsrf(url, {
            method: "post",
        })
            .then(function (result) {
                switch (result.data.action) {
                    case "redirect":
                        redirect(result.data.url);
                        break;
                    case "modal":
                        self.initModal(result.data.modal);
                        break;
                }
            })
            .catch(function (error) {
                const errorMessage =
                    error.responseJSON?.message ||
                    "An unexpected error occurred.";
                Toolbox.error(errorMessage);
            })
            .always(function () {
                SubmitLoading.finishLoading(self.$btn);
                self.$btn.removeClass("loading");
            });
    }

    initModal(html) {
        $(".modal-hire").remove();
        $("body").append(html);

        var $modalHire = $(".modal-hire");
        new HireModal($modalHire);
    }
}

export default HireButton;
